// MeetingRoom Add
import styled from "@emotion/styled";
import {
  DeviceType,
  MediaStyleProperties,
  StyledComponentProps,
} from "../../../system/types/style/StyledComponentProps";

export const PageContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  /* align-items: stretch; */
`;

const CusCotainerOverflowY = {
  pc: "auto",
  tablet: "visible",
  mobile: "visible",
};
export const CusContainer = styled.div<StyledComponentProps>`
  display: flex;
  flex: 1;
  overflow-y: ${({ deviceType }) => CusCotainerOverflowY[deviceType]};
`;

const GridContainerMinWidth: MediaStyleProperties = {
  pc: "1200px",
  tablet: "600px",
  mobile: "360px",
};
const GridContainerMaxWidth: MediaStyleProperties = {
  pc: "1280px",
  tablet: "1200px",
  mobile: "600px",
};
// const GridContainerHeight: MediaStyleProperties = {
//   pc: "800px",
//   tablet: "calc(100dvh - 80px)",
//   mobile: "calc(100dvh - 80px)",
// };
// const GridContainerMinHeight: MediaStyleProperties = {
//   pc: "600px",
//   tablet: "600px",
//   mobile: "auto",
// };
const GridContainerPadding: MediaStyleProperties = {
  pc: "0",
  tablet: "0",
  mobile: "8px",
};
export const GridContainerStyle = (deviceType: DeviceType) => {
  return {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    minWidth: GridContainerMinWidth[deviceType],
    maxWidth: GridContainerMaxWidth[deviceType],
    padding: GridContainerPadding[deviceType],
  };
};
